<template>
  <BaseCircleButton
    size="lg"
    @click="settingsStore.openShare"
    variant="transparent"
  >
    <Icon name="ph:share-fat" class="sm:size-6 size-5" />
  </BaseCircleButton>
</template>

<script setup lang="ts">
import { useSettingsStore } from "~/stores/settings";

const settingsStore = useSettingsStore();
</script>
